import { render, staticRenderFns } from "./ItemOverlay.vue?vue&type=template&id=3dec0062&scoped=true"
import script from "./ItemOverlay.vue?vue&type=script&lang=js"
export * from "./ItemOverlay.vue?vue&type=script&lang=js"
import style0 from "./ItemOverlay.vue?vue&type=style&index=0&id=3dec0062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec0062",
  null
  
)

export default component.exports